export const objectToNullNmmDomain = (domain) => {
    const name = typeof domain === "string" ? domain : domain?.name;
    return {
        ...domain,
        name,
        text: { all: { he: name, ar: name } },
        cardDomainImg: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/prod/images/matriculation/defaultCardDomain.png",
        widgetImage: "https://storage.googleapis.com/dgt-gcp-moe-digital-campus-test/prod/images/matriculation/defaultWidgetDomain.png",
        color: "#ccc"
    }
}